var link_preview_default = {
  "fontElementMap": "iDLTE",
  "linkPreview": "_8zY3H",
  "linkPreviewImage": "txgjb",
  "linkPreviewInfo": "qTCr0",
  "linkPreviewTitle": "t4cd6",
  "ellipsis": "H0JEb",
  "linkPreviewDescription": "ot2aD",
  "linkPreviewUrl": "KLLEt"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
